<template>
    <router-view></router-view>
</template>

<script type="text/javascript">
    export default {
        components: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/user/index.vue